import { StyleSheet } from 'react-native';

const createStyles = (styleData: Record<string, any>) => {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      height: 40,
      width: styleData.width,
      borderRadius: styleData.borderRadius,
      backgroundColor:
        styleData.type === 'contained' ? styleData.backgroundColor : '',
      opacity: styleData.opacity,
      justifyContent: 'center',
      alignItems: 'center',
      borderColor: styleData.borderColor,
      borderWidth: styleData.borderWidth,
      borderStyle: styleData.borderStyle,
      paddingHorizontal: 12,
    },
    iconContainer: {
      marginRight: 8,
      alignItems: 'center',
      justifyContent: 'center',
    },
    text: {
      fontSize: styleData.fontSize ?? 16,
      color: styleData.type === 'contained' ? styleData.color : '#000000',
      fontFamily: styleData.fontFamily,
      fontWeight: styleData.fontWeight?.toString(),
      opacity: styleData.opacity,
      textAlign: 'center',
    },
    errorContainer: {
      borderRadius: styleData.borderRadius,
      opacity: styleData.opacity,
      textAlign: 'center',
      borderColor: '#000000',
      borderStyle: 'solid',
      borderWidth: 2,
      justifyContent: 'center',
      minHeight: 40,
      width: styleData.width,
      paddingHorizontal: 8,
      backgroundColor: '#FFFFFF',
    },
    errorText: {
      fontSize: styleData.fontSize ?? 14,
      color: '#FF0000',
      fontFamily: styleData.fontFamily,
      fontWeight: styleData.fontWeight?.toString(),
      textAlign: 'center',
    },
  });
};

export default createStyles;
